// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3cqud","errorLogs":"styles_errorLogs__2zSFd"};